import { List, ListSubheader, Divider } from '@mui/material';
import ScrollToBottom from 'src/component-project/ScrollToBottom';
import { eventList, glb_sv, serviceList, sendRequest } from 'src/utils';
import { useEffect, useRef, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import NotificationItem from '../NotificationItem';

const ListNotification = ({
    value,
    totalNotification,
    listNotification,
    handleClose,
    handleScrollToBottom,
    loading,
}) => {

    return (
        <>
            {value === 'notify' && totalNotification > 0 ? (
                <>
                    <List
                        disablePadding
                        subheader={
                            <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                                {t('not_read')}
                            </ListSubheader>
                        }
                    >
                        {listNotification.map((notification, index) =>
                            notification.status_notify === '1' &&
                            notification?.key_funct !== 'er1' &&
                            notification?.key_funct !== 'er2' &&
                            notification?.key_funct !== 'er3' ? (
                                <NotificationItem key={index} notification={notification} handleClose={handleClose} />
                            ) : (
                                ''
                            )
                        )}
                        {/* <ScrollToBottom onScrollToBottom={handleScrollToBottom} loading={loading} /> */}
                    </List>

                    <Divider sx={{ borderStyle: 'dashed' }} />

                    <List
                        disablePadding
                        subheader={
                            <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                                {t('reader')}
                            </ListSubheader>
                        }
                    >
                        {listNotification.map((notification, index) =>
                            notification.status_notify === '0' &&
                            notification?.key_funct !== 'er1' &&
                            notification?.key_funct !== 'er2' &&
                            notification?.key_funct !== 'er3' ? (
                                <NotificationItem key={index} notification={notification} handleClose={handleClose} />
                            ) : (
                                ''
                            )
                        )}
                        <ScrollToBottom onScrollToBottom={handleScrollToBottom} loading={loading} />
                    </List>
                </>
            ) : (
                ''
            )}
        </>
    );
};

export default ListNotification;
